export const CUSTOMER_ID_MAP = {
  TEST_DATA: "3310591f-0e19-4e6b-95bc-5dbebc7a63c6",
  ELHT: "2d36457f-8036-4bcd-9394-7f0e08f0e0d5",
  UCLH: "079ac124-1760-41d0-b5ec-92b62c7ae4f3",
  BHT: "6122da62-0d08-43e6-9895-65a5d9690f34",
  ASP: "b9d7f682-12fb-4dec-a5db-3da5b7716bbf",
  UHCW: "030b7191-f6cc-4c79-aeef-13801f472299",
  RFT: "c3a5961f-f955-4891-ac10-8fc1a011266f",
  LNW: "f98fa840-8635-4be4-8460-b63d324f4e81",
  THH: "82afdd59-5d32-47de-97c8-42ff80b59692",
};
